var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"all"},[_c('Select',{staticClass:"select-role",attrs:{"options":_vm.rolesList},model:{value:(_vm.selectedRole),callback:function ($$v) {_vm.selectedRole=$$v},expression:"selectedRole"}}),_c('button',{attrs:{"type":"button"},on:{"click":_vm.submit}},[_vm._v("Submit")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }